import React, { Component } from 'react';

export default class SearchInput extends Component {
    timerId = 0;

    componentDidUpdate(oldProps) {
        if (!oldProps.open && this.props.open) this.inpNode.focus();
    }

    handleChange = event => {
        const text = event.target.value.trim();

        if (text.length) {
            clearTimeout(this.timerId);
            return (this.timerId = setTimeout(() => this.props.onChangeInput(text), 1500));
        }

        clearTimeout(this.timerId);
        setTimeout(() => this.props.onChangeInput(''), 1500);
    };

    inputRef = node => {
        this.inpNode = node;
        this.props.getInput(this.inpNode);
    };

    render() {
        return <input type="text" placeholder="Search" onChange={this.handleChange} ref={this.inputRef} />;
    }
}



// WEBPACK FOOTER //
// ./src/UI/Containers/Search/SearchInput.js